export interface AntiForgeryToken {
    name: string;
    value: string;
}

export default function GetAntiForgeryToken(): AntiForgeryToken | null {
    const tokenWindow = window;
    const tokenName = "__RequestVerificationToken";
    const tokenField = $(tokenWindow.document).find("input[type='hidden'][name='" + tokenName + "']");
    if (tokenField.length == 0) { return null; }
    else {
        return {
            name: tokenName,
            value: tokenField.val()?.toString() ?? ''
        };
    }
};
